import { Defaults } from './constants/defaults';

export function openMailClientWithSupportPrefilled(): void {
  window.location.href = `mailto:${Defaults.RPX_EMAIL}`;
}
